import moment from "moment";
import { t } from "i18next";
import { useRef } from "react";
import { useSelector } from "react-redux";
import C from "Constants";
import { FormatPreOrderingTime } from "utils/OrderUtils";
import SlideInLayout from "components/layouts/SlideInLayout";
import { ChangeSelectedLocationToModalContainerOption } from "./ChangeDeliveringToModalContainer";

function ChangePickupStoreModalContainer({
  isContainerModalopen,
  setContainerModalopen,
  handleChangeOrderStore,
  setPreOrderingSlotWidget,
  preORderSlots,
  isPreORderEnabled,
}) {
  const elementRef = useRef(null);
  const { selectedStore } = useSelector((state) => state?.store);
  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);

  return (
    <>
      <SlideInLayout
        open={isContainerModalopen}
        handleClose={() => setContainerModalopen(false)}
        container={{
          className: `p-2`,
          style: {
            height: "fit-content",
          },
        }}
      >
        <div
          id="discount-info-popup"
          className="flex flex-col gap-2 p-2 top-border-rounded"
          ref={elementRef}
        >
          <ChangeSelectedLocationToModalContainerOption
            onClick={() => {
              handleChangeOrderStore();
              setContainerModalopen(false);
            }}
            title={"Selected Store"}
            subTitle={
              selectedStore?.baseLanguage?.name
                ? selectedStore?.baseLanguage?.name
                : "Select store"
            }
          />
          <ChangeSelectedLocationToModalContainerOption
            onClick={() => {
              // if (isPreORderEnabled && preORderSlots?.length > 0) {
                setPreOrderingSlotWidget(true);
                setContainerModalopen(false);
              // }
            }}
            title={"Pickup Time"}
            subTitle={
              orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER &&
              orderTiming?.preOrderSlot?.day &&
              orderTiming?.preOrderSlot?.time
                ? `${
                    orderTiming?.preOrderSlot?.day === C.TODAY
                      ? t(orderTiming?.preOrderSlot?.day)
                      : moment(orderTiming?.preOrderSlot?.day).format(
                          "dddd, DD MMM YYYY"
                        )
                  }, ${FormatPreOrderingTime(orderTiming?.preOrderSlot?.time)}`
                : "ASAP"
            }
            subTitleTag="span"
          />
        </div>
      </SlideInLayout>
    </>
  );
}

export default ChangePickupStoreModalContainer;
